import React, { useCallback, useEffect } from 'react'
import { useKonva } from '../context/KonvaContext'
import { FaRegSquare } from 'react-icons/fa'
import { IoTriangleOutline } from 'react-icons/io5'
import { FaRegCircle } from 'react-icons/fa6'
import { RiRectangleLine } from 'react-icons/ri'
import { TbSquareLetterL } from 'react-icons/tb'
import { IoMdHelp } from "react-icons/io"
import {
    FaPen,
    FaUndo,
    FaRedo,
    FaSearchPlus,
    FaSearchMinus,
} from 'react-icons/fa'
import ToolbarButton from './ToolBarActions'

const tools = [
    { type: 'pen', icon: <FaPen /> },
    { type: 'square', icon: <FaRegSquare /> },
    { type: 'rectangle', icon: <RiRectangleLine /> },
    { type: 'circle', icon: <FaRegCircle /> },
    { type: 'triangle', icon: <IoTriangleOutline /> },
    { type: 'LShape', icon: <TbSquareLetterL /> },
]

const ToolBar = () => {
    const { tool,
        setTool,
        setScale,
        shapes,
        setShapes,
        shapeData,
        setShapeData,
        shapeAreas,
        setShapeAreas,
        future,
        setFuture,
        shapesHistory,
        setIsHelpModalOpen } = useKonva()

    const handleUndoOperation = useCallback(() => {
        const lastShapeIndex = shapes.length - 1

        if (lastShapeIndex < 0) return

        const lastShape = shapes[lastShapeIndex]
        const lastShapeId = lastShape.id
        const shapeToRemove = (lastShape?.type === "rectangle" && Object.keys(lastShape).some(key => key === 'strokeWidth')) ? 2 : 1
        const updatedShapes = shapes.slice(0, -shapeToRemove)
        const { [lastShapeId]: removedShapeData, ...updatedShapeData } = shapeData
        const { [lastShapeId]: removeShapeArea, ...updatedShapeArea } = shapeAreas

        setShapes(updatedShapes)
        setShapeData(updatedShapeData)
        setShapeAreas(updatedShapeArea)
        setFuture([...future, lastShapeId])
    }, [shapes, setShapes, setShapeData, setShapeAreas, setFuture, future, shapeAreas, shapeData])

    const handleRedoOperation = useCallback(() => {
        if (!future.length) return

        const redoShapeId = future[future.length - 1]
        const redoShape = shapesHistory[redoShapeId]

        if (redoShape?.shape) {
            redoShape.shape.forEach((s) => {
                setShapes((prev) => [...prev, s])
            })
        }

        setShapeData((prev) => ({
            ...prev,
            [redoShapeId]: {
                dimensions: redoShape?.dimensions,
                possibleDimensions: redoShape?.possibleDimensions,
                currentSelectedDimension: redoShape?.currentSelectedDimension
            }
        }))
        setShapeAreas((prev) => ({
            ...prev,
            [redoShapeId]: redoShape?.shapeArea || 0
        }))

        const updateFuture = future.filter((id) => id !== redoShapeId)
        setFuture(updateFuture)
    }, [future, setFuture, setShapeAreas, setShapeData, setShapes, shapesHistory])

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'z') {
                e.preventDefault()
                handleUndoOperation()
            }
            if (e.ctrlKey && e.key === 'y') {
                e.preventDefault()
                handleRedoOperation()
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [handleUndoOperation, handleRedoOperation])

    return (
        <div className="shap_wrapper">
            <div className="toolbar">
                <h3>TURF RABBIT</h3>
                <div>
                    {tools.map(({ type, icon }) => (
                        <ToolbarButton
                            key={type}
                            active={tool === type}
                            onClick={() => setTool(type)}
                            type={type}
                        >
                            {icon}
                        </ToolbarButton>
                    ))}
                    <ToolbarButton type={'Zoom out'} onClick={() => setScale(prevScale => prevScale * 1.1)}>
                        <FaSearchPlus />
                    </ToolbarButton>
                    <ToolbarButton type={'Zoom in'} onClick={() => setScale(prevScale => prevScale / 1.1)}>
                        <FaSearchMinus />
                    </ToolbarButton>
                    <ToolbarButton type={'Undo'} onClick={handleUndoOperation}>
                        <FaUndo />
                    </ToolbarButton>
                    <ToolbarButton type={'Redo'} onClick={handleRedoOperation}>
                        <FaRedo />
                    </ToolbarButton>
                    <ToolbarButton type={'help'} onClick={() => {
                        setIsHelpModalOpen(true)
                    }}>
                        <IoMdHelp />
                    </ToolbarButton>
                </div>
            </div>
        </div>
    )
}

export default ToolBar